//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import swiperContainer from '~/components/swiper';

export default {
  components: {
    swiperContainer,
  },
  async fetch() {
    await this.$store.dispatch('resourcesStore/getResources', this.queries.highlightVideos)
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: {queries} }) => queries,
      highlightVideos: ({ resourcesStore: {highlightVideos} }) => highlightVideos,
      loading: ({ resourcesStore: {loading} }) => loading
    }),
  },
};
